import React from 'react';
import MaterialButton, { ButtonProps } from '@mui/material/Button';
import { useTheme } from 'hooks';
import { tokens } from 'theme';
import { ValueOf } from 'types/types';
import { ButtonType } from 'types/enums';
import styles from './styles.module.sass';

type Props = {
  buttonType: ValueOf<typeof ButtonType>;
  isLoading?: boolean;
  children?: React.ReactNode;
} & Omit<ButtonProps, 'color' | 'className'>;

export const Button: React.FC<Props> = ({ children, buttonType, isLoading = false, ...props }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MaterialButton
      {...props}
      sx={{
        backgroundColor: colors.button.background[buttonType],
        color: colors.button.text[buttonType],
        '&:hover': {
          backgroundColor: colors.button.hover.background[buttonType],
          color: colors.button.hover.text[buttonType],
        },
        '&:focus': {
          backgroundColor: colors.button.hover.background[buttonType],
          color: colors.button.hover.text[buttonType],
        },
        '&:disabled': {
          color: colors.button.hover.text[buttonType],
        },
      }}
      className={styles.button}
    >
      {isLoading ? 'Loading...' : children}
    </MaterialButton>
  );
};
